import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

const colorMap = {
  red: "bg-rose-500 hover:bg-rose-600 text-white",
  emerald: "bg-emerald-600 hover:bg-emerald-700 text-white",
  amber: "bg-amber-500 hover:bg-amber-600 text-white",
  slate: "bg-slate-600 hover:bg-slate-700 text-white",
  // legacy
  indigo: "bg-emerald-600 hover:bg-emerald-700 text-white",
  yellow: "bg-amber-500 hover:bg-amber-600 text-white",
  gray: "bg-slate-600 hover:bg-slate-700 text-white",
};

const FixedBanner = ({ icon, message, actionText, actionLink, color }) => {
  const bgClass = colorMap[color] ?? colorMap.slate;
  const content = (
    <div className="flex w-full items-center justify-between gap-4 rounded-xl px-4 py-3">
      <div className="flex items-center gap-3">
        <span className="flex shrink-0 opacity-95">{icon}</span>
        <p className="text-sm font-medium sm:text-base">{message}</p>
      </div>
      {actionText && actionLink && (
        <span className="shrink-0 font-semibold underline opacity-95 hover:opacity-100">
          {actionText} →
        </span>
      )}
    </div>
  );

  if (actionLink && actionText) {
    return (
      <NavLink to={actionLink} className={`mb-4 block w-full rounded-xl ${bgClass} transition`}>
        {content}
      </NavLink>
    );
  }

  return (
    <div className={`mb-4 block w-full rounded-xl ${bgClass} transition`}>
      {content}
    </div>
  );
};

FixedBanner.propTypes = {
  icon: PropTypes.node,
  message: PropTypes.string.isRequired,
  actionText: PropTypes.string,
  actionLink: PropTypes.string,
  color: PropTypes.string.isRequired,
};

export default FixedBanner;
